/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  companyWorkbenchData,
  companyWorkbenchLoading,
  selectCompanyIntentData,
  selectCompanyIntentLoading,
  selectCompanyNews,
  selectCompanyNewsEnded,
  selectCompanyNewsFiltersSelected,
  selectCompanyNewsPageNumber,
  selectCompanyPulse,
  selectCompanyPulseLoading,
  selectIsEmptyStats,
  selectNewsLoading,
  selectNewsFlurry,
  selectNewsCall,
  selectNewsFilterApplied,
  selectSWOTLoading,
  selectSWOTData,
  strategicHighlightsLoading
} from 'Selector/CompaniesSelector';
import { CompanyPulse } from 'Types/GlobalSearchResultsTypes';
import { Article } from 'Types/ArticleTypes';
// import { Article, LinkedInPost } from 'Types/ArticleTypes';
import ArticleHeroSkeleton from 'Components/common/skeleton/ArticleHeroSkeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import ArticleTileGlobal from 'Components/common/components/ArticleTileGlobal';
import SocialCardSkeleton from 'Components/common/skeleton/SocialCardSkeleton';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { WorkbenchStatsResponseType } from 'Types/PersonTypes';
import WorkbenchStat from 'Components/common/components/WorkbenchStat';
import { CompanyIntent } from 'Types/CompaniesTypes';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  isFreeUser, valueToObject,
} from 'Utils/UtilityFunctions';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import { NODATABASEDONFILTERS } from 'Utils/Constants';
import styled from 'styled-components';
import {
  boxShadow, maxMobile, maxTablet, midMobile, primaryFont,
  primaryHeadingColor, secondaryFont, smMobile, wMBold, wMedium, white,
} from 'Utils/utilsStyle';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';
import classNames from 'classnames';
import { Waypoint } from 'react-waypoint';
import HeatMapProgress from '../../common/components/HeatMapProgress';
import IntentDataCompanies from '../../common/components/IntentDataCompanies';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';
import SwotAnalysis from './SwotAnalysis';
import StrategicHighlights from '../../common/components/StrategicHighlights';
import { StrategicHighlight } from '../../../Types/GlobalTypes';
import StrategicHighlightsSkeleton from '../../common/skeleton/StrategicHighlightsSkeleton';
import { TagItem } from '../../../Types/ChatBotV2Types';
import { selectShowChatbot, selectShowGlobalGilroy } from '../../../Selector/GlobalSearchContentSelector';
import {
  selectClusterCompanyNews, selectClusterCompanyNewsEnded,
  selectClusterCompanyNewsFilterSelected, selectClusterCompanyNewsLoading,
  selectClusterCompanyPageNumber,
  selectSelectedClusterCompanies,
  selectClusterCompanyNewsCompanyIdsApplied,
  selectClusterCompanyNewsFiltersApplied,
  selectClusterNewsFilterApplied,
} from '../../../Selector/ClustersSelector';
import { actions as clusterActions } from '../../../Slice/ClustersSlice';

const Wrapper = styled.div`
  .swot-analysis-area {
    margin-bottom: 24px;
  }
  .content-swat-wrapper {
    margin-top: 25px;
  }
  &.companyNewsTabWrapper{
    .spacing-manage {
      padding-top: 100px;
      padding-bottom: 100px;
    }
    .tagsAndIntentDataWrapper{
      padding: 24px;
      background: ${white};
      border-radius: 16px;
      box-shadow: ${boxShadow};
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;

      @media all and (max-width: ${maxMobile}) {
        padding: 16px 10px;
        margin-bottom: 24px;
      }

      .heading-inner-page{
        margin-bottom: 16px;
      }
      .engagementOverviewWrapper{
        display: flex;
        gap: 18px;

        @media all and (max-width: ${maxMobile}) {
          gap: 16px;
          flex-direction: column;
        }
        .workbenchStatWrapper,
        .intentDataWrapper{
          flex: 1;
          min-width: calc(50% - 10px);

          @media all and (max-width: ${maxMobile}) {
            min-width: calc(50% - 8px);
          }
        }
        .intentDataWrapper{
          display: flex;
        }
        .workbenchStatWrapper{
          &.dynamicWidth{
            .listview-wrapper{
              display: flex;
              align-items: center;
              gap: 10px;
              flex-wrap: wrap;

              @media screen and (max-width: ${maxTablet}) {
                align-items: center;
              }
              @media screen and (max-width: ${maxMobile}) {
                flex-direction: column;
                align-items: unset;
              }
              .activity_wrapper{
                gap: 8px;
                flex: 1;

                @media screen and (max-width: ${maxTablet}) {
                  flex-wrap: nowrap;
                }

                @media screen and (max-width: ${midMobile}) {
                  flex-wrap: wrap;
                }
                .data-entity{
                  margin: 0;
                  flex: 1;

                  @media screen and (max-width: ${maxTablet}) {
                    min-width: unset;
                    max-width: unset;
                    width: unset;
                  }
                  @media screen and (max-width: ${midMobile}) {
                    min-width:calc(50% - 4px);
                    max-width: calc(50% - 4px);
                  }
                }
              }
              .analyze_button{
                min-width: 241px;
                width: 241px;

                @media screen and (max-width: ${maxMobile}) {
                  width: 100%;
                }
                button{
                  border-radius: 100px;
                  color: ${white};
                  font-family: ${primaryFont};
                  font-size: 16px;
                  font-style: normal;
                  font-weight: ${wMedium};
                  line-height: 20px;
                  letter-spacing: -0.4px;
                  display: flex;
                  align-items: center;
                  gap: 9px;
                  height: 38px;

                  @media screen and (max-width: ${maxTablet}) {
                    padding: 4px 18px;
                  }
                  @media screen and (max-width: ${maxMobile}) {
                    width: 100%;
                    justify-content: center;
                    font-size: 14px;
                  }
                  @media screen and (max-width: ${smMobile}) {
                    font-size: 12px;
                  }
                  svg {
                    min-width: 17px;
                    min-height: 20px;
                    height: 20px;
                    margin: 0;
                    @media screen and (max-width: ${maxMobile}) {
                      min-width: 14px;
                    }
                  }
                }
              }
            }
            .statsChartWrapper{
              display: none !important;
            }
          }
        }
        
      }
    }
    .triggerWrapper{
      background: ${white};
      border-radius: 16px;
      box-shadow: ${boxShadow};
      .progress-wrapper{
        padding: 12px !important;
      }
      .spotlight-wrapper{
        padding: 24px 12px;

        @media all and (max-width: ${maxMobile}) {
          padding: 16px 0px;
        }
      }
      .heading-inner-page,
      .infiniteScrollWrapper{
        padding: 0 12px;

        @media all and (max-width: ${maxMobile}) {
          padding: 0px 10px;
        }
      }
    }
  }
  .highlight-skeleton {
    padding-bottom: 30px;
  }
`;

const getArticleKey = (article: Article) => {
  if (article.articleType.toLowerCase() === 'news') return article.articleId;
  if (article.articleType.toLowerCase() === 'tweet') return article.tweetData.tweetId;
  if (article.articleType.toLowerCase() === 'linkedin') return article.linkedinData.id;
  return article.articleId;
};

export const getArticleColumn = (
  article: Article,
  listview: boolean,
  isGroup?: boolean,
  popoverCustomClass?: string,
) => {
  if (article?.articleType
    && (article?.articleId)) {
    const columnNumber = (listview ? 24 : 12);
    return (
      <Col
        span={columnNumber}
        xs={24}
        sm={24}
        md={columnNumber}
        className="article-grid"
        style={{
          width: '100%',
        }}
        key={getArticleKey(article)}
      >
        <ArticleTileGlobal
          hideCompanyName
          heroArticle
          activityTile
          article={article}
          articleHeight="280"
          articleWidth="570"
          listView={listview}
          popoverCustomClass={popoverCustomClass}
        />
      </Col>
    );
  }
  return null;
};

export const getArticleAndSocialSkeletons = () => (
  <Row>
    {/* 1 for ArticleHeroSkeleton and 2 for SocialCardSkeleton */}
    {[1, 1, 2, 1, 2, 1, 2].map((item) => (
      <Col
        span={12}
        xs={24}
        sm={24}
        md={12}
        className="article-grid"
        style={{
          width: '100%',
        }}
      >
        {item === 1 ? <ArticleHeroSkeleton /> : <SocialCardSkeleton />}
      </Col>
    ))}
  </Row>
);

const getArticleSkeleton = () => (
  <Row gutter={[16, 16]}>
    {[1, 2, 3, 4, 5, 6].map((item) => (
      <Col
        key={`${item}skeleton`}
        span={12}
        xs={24}
        sm={24}
        md={12}
        className="article-grid"
        style={{
          width: '100%',
        }}
      >
        <ArticleHeroSkeleton />
      </Col>
    ))}
  </Row>
);

type Props = {
  listview: boolean;
  strategicHighlights?: StrategicHighlight[],
  handleHighlightClick?: (prompt: string) => void,
  onGilroyClose?: () => void;
  tagCompany?: TagItem;
  isCluster?: boolean;
} & typeof defaultProps;

const defaultProps = {
  listview: false,
  onGilroyClose: () => { },
};

const CompanyNewsTab = function CompanyNewsTab(props: Props) {
  const dispatch = useDispatch();
  const { listview, onGilroyClose, isCluster } = props;
  const [showSection, setShowSection] = useState(true);
  const [showSectionSWOT, setShowSectionSWOT] = useState(true);

  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyPulse: CompanyPulse[] | null = useSelector(selectCompanyPulse);
  const companyPulseLoading: boolean = useSelector(selectCompanyPulseLoading);
  const companyNewsArticles: Article[] | null = isCluster ? useSelector(selectClusterCompanyNews) : useSelector(selectCompanyNews);
  const newLoading: boolean = isCluster ? useSelector(selectClusterCompanyNewsLoading) : useSelector(selectNewsLoading);
  const companyNewsEnded: boolean = isCluster ? useSelector(selectClusterCompanyNewsEnded) : useSelector(selectCompanyNewsEnded);
  const companyNewsPageNumber: number = isCluster ? useSelector(selectClusterCompanyPageNumber) : useSelector(selectCompanyNewsPageNumber);
  const selectedFilter: string = isCluster ? useSelector(selectClusterCompanyNewsFilterSelected) : useSelector(selectCompanyNewsFiltersSelected);
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const companyIntentData: CompanyIntent | null = useSelector(selectCompanyIntentData);
  const companyIntent = companyIntentData?.companyIntent;
  const companyIntentLoading: boolean = useSelector(selectCompanyIntentLoading);
  const flurryObject = useSelector(selectNewsFlurry);
  const isCalled = useSelector(selectNewsCall);
  const companyWorkbenchStats: WorkbenchStatsResponseType[] = useSelector(companyWorkbenchData);
  const companyWorkbenchStatsLoading: boolean = useSelector(companyWorkbenchLoading);
  const isEmptyStats: boolean = useSelector(selectIsEmptyStats);
  const newsFilterApplied: boolean = isCluster
    ? useSelector(selectClusterNewsFilterApplied)
    : useSelector(selectNewsFilterApplied);
  const swotLoading = useSelector(selectSWOTLoading);
  const swotData = useSelector(selectSWOTData);
  const chatbotAllowed = useSelector(selectShowChatbot);
  const allowGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const highlightsLoading = useSelector(strategicHighlightsLoading);
  const selectedClusterCompanies = useSelector(selectSelectedClusterCompanies);
  const companyNewsCompanyIdsApplied = useSelector(selectClusterCompanyNewsCompanyIdsApplied);
  const clusterFiltersApplied = useSelector(selectClusterCompanyNewsFiltersApplied);

  useEffect(() => {
    const flurryValues = Object.values(flurryObject);
    if (Object.keys(flurryObject).length && flurryValues[0] === companyIdParsed) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('company_news', 0, {
          ...flurryObject,
          isDeleteTime: true,
          ...isCalled && { isCalled },
        }),
      ));
      dispatch(companiesActions.setNewsCall(true));
    }
  }, [flurryObject]);

  const fetchMoreNews = () => {
    if (isCluster) {
      if (
        companyNewsArticles
        && companyNewsArticles?.length
        && !newLoading
      ) {
        const selectedIds = selectedClusterCompanies.map((item) => item.companyId);
        const newsCompanyIds = companyNewsCompanyIdsApplied || selectedIds.join(',');
        const newsFilters = selectedFilter || clusterFiltersApplied;
        dispatch(clusterActions.getClusterCompanyNews({
          companyId: newsCompanyIds,
          page: companyNewsPageNumber,
          ...newsFilters.length ? {
            newsFilters,
          } : {},
        }));
      }
    } else {

      if (
        companyNewsArticles
        && companyNewsArticles?.length
        && !newLoading
      ) {
        dispatch(companiesActions.getCompanyNews({
          companyId: companyIdParsed,
          page: companyNewsPageNumber,
          ...selectedFilter.length ? {
            newsFilters: selectedFilter,
          } : {},
          // ...filtersApplied?.length ? {
          //   newsFilters: filtersApplied,
          // } : {},
        }));
      }
    }
  };

  const getPulse = () => {
    if (
      companyPulse?.length
    ) {
      return <HeatMapProgress pulse={companyPulse} />;
    }
    return null;
  };

  useEffect(() => {
    if (!newLoading && !companyNewsArticles?.length && !newsFilterApplied) setShowSection(false);
    else setShowSection(true);
  }, [newLoading, companyNewsArticles]);

  useEffect(() => {
    if (!swotLoading && !swotData?.swotAnalysis.length) setShowSectionSWOT(false);
    else setShowSectionSWOT(true);
  }, [swotLoading, swotData]);

  return (
    <Wrapper className="companyNewsTabWrapper">
      {props.strategicHighlights && props.strategicHighlights.length <= 0 && null}
      {chatbotAllowed && allowGlobalGilroy && props.strategicHighlights && props.strategicHighlights.length > 0 ? (
        <Waypoint
          onEnter={() => dispatch(companiesActions.pushCurrentSection('Strategic Highlights'))}
          onLeave={() => dispatch(companiesActions.removeCurrentSection('Strategic Highlights'))}
          bottomOffset="20%"
        >
          <div id="strategic-highlights-section">
            <StrategicHighlights
              strategicHighlights={props.strategicHighlights}
              handleClick={props.handleHighlightClick}
              onGilroyClose={onGilroyClose}
            />
          </div>
        </Waypoint>
      ) : (
        (!highlightsLoading && props.strategicHighlights?.length === 0)
          ? null
          : <StrategicHighlightsSkeleton />
      )}

      {showSectionSWOT
        ? (
          <Waypoint onEnter={() => dispatch(companiesActions.pushCurrentSection('S.W.O.T'))} onLeave={() => dispatch(companiesActions.removeCurrentSection('S.W.O.T'))} bottomOffset="60%" topOffset={250}>
            <div className="spotlight-wrapper swot-analysis-area company-swot-section">
              <SwotAnalysis
                isSwotTab={false}
              />
            </div>
          </Waypoint>
        ) : null}

      {!listview ? (
        companyIntent && companyIntent.length > 1 && !isFreeUser() && (
          <div className="tagsAndIntentDataWrapper">
            <div className="heading-inner-page">
              {!companyIntentLoading && !companyWorkbenchStatsLoading ? <h1 className="heading">Engagement Overview</h1> : <SkeletonCustom width="210px" height="45px" diameter="10px" />}
            </div>
            {companyIntent?.length === 0 && isEmptyStats ? (
              null
            ) : (
              <div
                className="engagementOverviewWrapper"
              >
                {!companyIntentLoading
                  && companyIntent?.length !== 0
                  && (
                    <div className="intentDataWrapper">
                      <IntentDataCompanies listview={listview} />
                    </div>
                  )}

                {!companyWorkbenchStatsLoading && !isEmptyStats && !isFreeUser()
                  && (
                    <div className={classNames('workbenchStatWrapper', {
                      dynamicWidth:
                        !(companyNewsArticles && companyNewsArticles.length > 1),
                    })}
                    >
                      <WorkbenchStat
                        loading={companyWorkbenchStatsLoading}
                        stats={companyWorkbenchStats}
                        listview={listview}
                        isSignleArticle={!(companyNewsArticles && companyNewsArticles.length > 1)}
                      />
                    </div>
                  )}

              </div>
            )}
          </div>
        )
      ) : (
        <div className="listviewTagsAndStatsWrapper classToMakePrecedenceHigh">
          {!companyWorkbenchStatsLoading && !isEmptyStats && !isFreeUser()
            && (
              <div className={classNames('workbenchStatWrapper', {
                dynamicWidth:
                  !(companyNewsArticles && companyNewsArticles.length > 1),
              })}
              >
                <h2 className="headingText">
                  Workbench Engagement
                </h2>
                <WorkbenchStat
                  loading={companyWorkbenchStatsLoading}
                  stats={companyWorkbenchStats}
                  listview={listview}
                />
              </div>
            )}

          {!companyIntentLoading
            && companyIntent?.length !== 0
            && (
              <div className="intentDataWrapper">
                <IntentDataCompanies listview={listview} />
              </div>
            )}
        </div>
      )}
      <Waypoint onEnter={() => dispatch(companiesActions.pushCurrentSection('Sales Triggers'))} onLeave={() => dispatch(companiesActions.removeCurrentSection('Sales Triggers'))}>
        <div id="trigger-details" className="triggerWrapper company-news-section">
          {showSection
            && (
              <div className="spotlight-wrapper">
                <div className="heading-inner-page">
                  {
                    (!newLoading) ? (
                      <h1 className="heading">
                        {isCluster ? "Sales Triggers" : "Triggers"}
                      </h1>
                    ) : (
                      <SkeletonCustom
                        width="210px"
                        height="45px"
                        diameter="10px"
                      />
                    )
                  }
                </div>
                {
                  (!companyPulseLoading && !isCluster) ? getPulse() : !isCluster && <SkeletonCustom width="100%" height="5px" />
                }
                {!newLoading && selectedFilter.length > 0
                  && companyNewsArticles && companyNewsArticles.length < 1
                  && (
                    <Col span={24} className="article-grid spacing-manage">
                      <NoPersonsFound title={NODATABASEDONFILTERS} />
                    </Col>
                  )}
                <InfiniteScroll
                  dataLength={companyNewsArticles ? companyNewsArticles.length : 0}
                  next={fetchMoreNews}
                  hasMore={!companyNewsEnded}
                  loader={false}
                  className="o-x-hidden o-y-hidden infiniteScrollWrapper"
                >
                  <div className="newsArticleWithListview">
                    <ArticleGridLayout
                      articlesArray={companyNewsArticles}
                      listview={listview}
                    />

                    {newLoading && !companyNewsEnded
                      && (listview
                        ? <ArticleListLoadingSkeletonBundle />
                        : <ArticleLoadingSkeletonBundle />)}
                  </div>
                </InfiniteScroll>
              </div>
            )}
        </div>
      </Waypoint>
    </Wrapper>
  );
};

export default React.memo(CompanyNewsTab);
